export interface PlinkoPeg
{
  x: number;
  y: number;
}

export class PlinkoLayout
{
  static readonly BOARD_W = 906;
  static readonly BOARD_H = 1293;

  static readonly WALL_LEFT = 43;
  static readonly WALL_RIGHT = 863;

  static readonly HOLE_W = 606;
  static readonly HOLE_H = 118;
  static readonly HOLE_X = ( PlinkoLayout.BOARD_W - PlinkoLayout.HOLE_W ) / 2;
  static readonly HOLE_Y = 134;
  static readonly HOLE_LINE = 10;

  static readonly PEG_RADIUS = 10;
  static readonly PEG_ROWS = 7;
  static readonly PEG_FIRST_Y = 318;
  static readonly PEG_ROW_STEP = 96;
  static readonly PEG_STEP_X = 94;
  static readonly PEG_WIDE_X = 77;
  static readonly PEG_WIDE_COUNT = 9;
  static readonly PEG_NARROW_X = 124;
  static readonly PEG_NARROW_COUNT = 8;

  static readonly DIVIDER_FIRST_X = 124;
  static readonly DIVIDER_STEP_X = 94;
  static readonly DIVIDER_COUNT = 8;
  static readonly DIVIDER_TOP = 1000;
  static readonly DIVIDER_HALF_W = 7;

  static readonly FLOOR_Y = 1090;
  static readonly SLOTS_H = PlinkoLayout.BOARD_H - PlinkoLayout.FLOOR_Y;

  static readonly BALL_RADIUS = 26;

  static readonly CANNON_PIVOT_X = PlinkoLayout.BOARD_W / 2;
  static readonly CANNON_LENGTH = 340;
  static readonly CANNON_MAX_ANGLE = 0.45;

  static pegs(): PlinkoPeg[]
  {
    const pegs: PlinkoPeg[] = [];

    for ( let row = 0; row < PlinkoLayout.PEG_ROWS; row++ )
    {
      const wide = row % 2 === 0;
      const first_x = wide ? PlinkoLayout.PEG_WIDE_X : PlinkoLayout.PEG_NARROW_X;
      const count = wide ? PlinkoLayout.PEG_WIDE_COUNT : PlinkoLayout.PEG_NARROW_COUNT;
      const y = PlinkoLayout.PEG_FIRST_Y + row * PlinkoLayout.PEG_ROW_STEP;

      for ( let i = 0; i < count; i++ )
        pegs.push( { x: first_x + i * PlinkoLayout.PEG_STEP_X, y } );
    }

    return pegs;
  }

  static dividerX( index: number ): number
  {
    return PlinkoLayout.DIVIDER_FIRST_X + index * PlinkoLayout.DIVIDER_STEP_X;
  }

  static slotIndex( x: number ): number
  {
    let index = 0;
    for ( let i = 0; i < PlinkoLayout.DIVIDER_COUNT; i++ )
      if ( x > PlinkoLayout.dividerX( i ) )
        index = i + 1;
    return index;
  }

  static slotLeft( index: number ): number
  {
    return index === 0 ? PlinkoLayout.WALL_LEFT : PlinkoLayout.dividerX( index - 1 );
  }

  static slotRight( index: number ): number
  {
    return index === PlinkoLayout.DIVIDER_COUNT ? PlinkoLayout.WALL_RIGHT : PlinkoLayout.dividerX( index );
  }

  static slotCenterX( index: number ): number
  {
    return ( PlinkoLayout.slotLeft( index ) + PlinkoLayout.slotRight( index ) ) / 2;
  }

  static holeMinX(): number
  {
    return PlinkoLayout.HOLE_X + PlinkoLayout.HOLE_H / 2;
  }

  static holeMaxX(): number
  {
    return PlinkoLayout.HOLE_X + PlinkoLayout.HOLE_W - PlinkoLayout.HOLE_H / 2;
  }

  static isInHole( x: number, y: number ): boolean
  {
    return x >= PlinkoLayout.HOLE_X && x <= PlinkoLayout.HOLE_X + PlinkoLayout.HOLE_W
      && y >= PlinkoLayout.HOLE_Y && y <= PlinkoLayout.HOLE_Y + PlinkoLayout.HOLE_H;
  }

  static holeCenterY(): number
  {
    return PlinkoLayout.HOLE_Y + PlinkoLayout.HOLE_H / 2;
  }
}
